// extracted by mini-css-extract-plugin
export default {"container":"riskAssessment_container__ZR5UH","text":"riskAssessment_text__JaLOu"};